import { StaticQuery, graphql } from "gatsby"
import React from "react"

const ContactForm = () => (
  <StaticQuery
    query={graphql`
      query {
        wordpressPage(slug: {eq: "contact"}) {
            acf {
              contact_title
              contact_email
              contact_number
              contact_operating_time
              contact_address
            }
        }
      }
    `}
    render={data => (
        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="text-center mb-5">
                            <h3 className="title mb-3">{data.wordpressPage.acf.contact_title}</h3>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-7">
                        <div className="custom-form mb-5 mb-lg-0">
                            <form method="post" action="https://formspree.io/xlepzbev" name="contact-form" id="contact-form">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Name*</label>
                                            <input name="name" id="name" type="text" class="form-control" placeholder="Your name..." />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="_replyto">Email Address*</label>
                                            <input name="_replyto" id="email" type="email" class="form-control" placeholder="Your email..." />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <label for="message">Message*</label>
                                            <textarea name="message" id="comments" rows="4" class="form-control" placeholder="Your message..."></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <button type="submit" id="submit" name="send" class="btn btn-primary">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="contact-detail text-muted ml-lg-5">
                            <p className="">
                                <span>{data.wordpressPage.acf.contact_email}</span>
                            </p>
                            <p className="">
                                <span>{data.wordpressPage.acf.contact_website}</span>
                            </p>
                            <p className="">
                                <span>{data.wordpressPage.acf.contact_number}</span>
                            </p>
                            <p className="">
                                <span>{data.wordpressPage.acf.contact_operating_time}</span>
                            </p>
                            <p className="">
                                <span>{data.wordpressPage.acf.contact_address}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )}
  />
)

export default ContactForm